import {Inject, injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {HardwareInfo} from '@/model/system/HardwareInfo';

import {IApiService} from '@/services/IApi.service';
import {ISystemHardwareService} from '@/services/system/IHardware.service';

@injectable()
export class SystemHardwareService implements ISystemHardwareService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/hardware';

  private hardwareInfoSerializer = new TypedJSON(HardwareInfo);

  public async getInfo(): Promise<HardwareInfo> {
    return this.hardwareInfoSerializer.parse(await this.apiService.get(this.path))!;
  }
}
